export default __webpack_public_path__ + "static/media/nuvem.0c55b806.svg";